import { Component, OnInit, Input, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { URLSearchParams } from '@angular/http';

import { compareElements } from 'app/shared/validators/generic-validators';
import { SnackBarService } from 'app/services/snackbar.service';
import { MessageService } from 'app/services/messages.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { unsavedFormCheck } from 'app/shared/validators/generic-validators';

import { ChangePassword } from './change-password.model';

import { ChangePasswordService } from './change-password.service';

@Component({
  templateUrl: './change-password.component.html',
  providers: [ChangePasswordService]
})

/**
 * Dialog component to change user password.
 */
export class ChangePasswordComponent implements OnInit {
  @Input() changePassword: ChangePassword;

  changePasswordForm: FormGroup;
  savingPassword = false;

  formErrors = {
    'currentpassword': '',
    'newpassword': '',
    'confirmNewPassword': '',
  };

  validationMessages = {
    'currentpassword': {
      'required': 'Required field value.',
    },
    'newpassword': {
      'required': 'Required field value.',
    },
    'confirmNewPassword': {
      'required': 'Required field value.',
    },
  };

  constructor(private formBuilder: FormBuilder,
    private changePasswordService: ChangePasswordService,
    private snackBarService: SnackBarService,
    private dialogRef: MdDialogRef<ChangePasswordComponent>,
    private trackingService: TrackingService) {
  }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.changePasswordForm = this.formBuilder.group({
      currentpassword: ['', Validators.required],
      newpassword: ['', Validators.required],
      confirmNewPassword: ['', Validators.required],
    }, { validator: compareElements('newpassword', 'confirmNewPassword') });

    this.changePasswordForm.valueChanges.subscribe(data => this.onValueChanged(data));
    this.onValueChanged(); // (re)set validation messages now
  }

  onValueChanged(data?: any) {
    if (!this.changePasswordForm) {
      return;
    }
    const form = this.changePasswordForm;

    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && control.touched && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] += messages[key] + ' ';
        }
      }
    }
  }

  onSubmit({ value, valid }: { value: ChangePassword, valid: boolean }) {

    // @todo add check for characters that need to be escaped.

    this.savingPassword = true;
    const changePasswordModel = new ChangePassword();
    changePasswordModel.currentpassword = value.currentpassword;
    changePasswordModel.newpassword = value.newpassword;
    this.changePasswordService.changePassword(changePasswordModel).subscribe(
      response => {
        this.savingPassword = false;
        if (response.flagResult) {
          this.callSnackBarService(response);
          this.callTrackingService(TrackingConstants.SUCCESS);
          this.dialogRef.close();
        } else {
          // @todo temp solution.
          response.message = 'Change password failed. '.concat(response.message);
          this.callSnackBarService(response);
          this.callTrackingService(TrackingConstants.FAILURE);
        }
      },
      err => {
        this.savingPassword = false;
        this.callSnackBarService(err._body);
        this.callTrackingService(TrackingConstants.FAILURE);
      }
    );
  }

  callSnackBarService(response: any) {
    this.snackBarService.showStatus(response, MessageService.CHANGE_PASSWORD_SUCCESS, MessageService.CHANGE_PASSWORD_FAILURE);
  }

  callTrackingService(response: any) {
    this.trackingService.emitEvent(TrackingConstants.CHANGE_PASSWORD, TrackingConstants.SAVE_CHANGE_PASSWORD, response, 0);
  }

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    unsavedFormCheck(event, this.dialogRef, this.changePasswordForm);
  }
}



// WEBPACK FOOTER //
// ./src/app/header/usersettings/changepassword/change-password.component.ts